export function hasHover() {
  return {
    type: 'HAS_HOVER',
  };
}

export function day(day) {
  return {
    type: 'DAY',
    day,
  };
}

export function setDish(obj) {
  return {
    type: 'SET_DISH',
    obj,
  };
}

export function toggleWarning(name, bool) {
  return {
    type: 'TOGGLE_WARNING',
    name,
    bool,
  };
}

export function currentPage(name) {
  return {
    type: 'CURRENT_PAGE',
    name,
  };
}


// WEBPACK FOOTER //
// ./src/gui/actions.js